module.exports = __webpack_public_path__ + "img/gi_balapmaut.386eec10.png";